/**
 * PEST-RISK-LEGACY-SURFACES-FINAL-CONSISTENCY-FIX-1
 * Vocabulario de solo revisión para la superficie de señales de riesgo fitosanitario.
 */
export const diseaseRiskEs = {
  diseaseRisk: {
    title: "Señales de riesgo fitosanitario",
    subtitle:
      "Señales de riesgo basadas en meteorología, estado del cultivo, GDD y datos de campo/satélite disponibles.",
    selectParcel: "Seleccionar parcela",
    recalculate: "Recalcular",
    activeModels: "Modelos activos",
    howTitle: "Cómo se calcula la señal de riesgo",
    howBody:
      "Las señales de riesgo de plagas y enfermedades se estiman a partir del tipo de cultivo, condiciones meteorológicas, reglas por plaga/enfermedad, contexto satelital de vegetación disponible, GDD cuando está disponible y scouting de campo cuando existe. Son señales de apoyo a la revisión, no un diagnóstico fitosanitario oficial.",
    signalsAssessed: "Señales evaluadas",
    elevatedSignals: "Señales elevadas",
    intermediateSignals: "Señales intermedias",
    calculating: "Ejecutando modelos epidemiológicos...",
    noRisks: "No se detectaron señales de riesgo significativas",
    noRisksDesc:
      "Las condiciones actuales no favorecen el desarrollo de plagas ni enfermedades.",
    disease: "Enfermedad",
    pest: "Plaga",
    vulnerableStage: "Estado vulnerable",
    nonVulnerableStage: "Estado no vulnerable",
    weatherFavorable: "Meteorología favorable",
    weatherNotFavorable: "Meteorología no favorable",
    assessmentUpdated: "Evaluación actualizada",
    signalsAssessedCount: "señales evaluadas",
    gddNotUsed: "GDD disponible: {{value}} · no usado por esta regla",
    nextStepsTitle: "Siguientes pasos permitidos",
    nextStepMonitor: "Continuar el seguimiento",
    nextStepScouting: "Crear un registro de scouting",
    nextStepAgronomist: "Revisar la evidencia con un asesor agronómico cualificado",
    nextStepsNote:
      "SentinelCrop no sugiere productos, dosis, aplicaciones ni preparación de intervenciones.",
    referenceOnlyNote:
      "Solo señales de referencia. No sustituyen al estado fitosanitario canónico de la parcela.",
  },
};